import { render, staticRenderFns } from "./TutorSessionView.vue?vue&type=template&id=4a64d6a9&scoped=true&"
import script from "./TutorSessionView.vue?vue&type=script&lang=ts&"
export * from "./TutorSessionView.vue?vue&type=script&lang=ts&"
import style0 from "./TutorSessionView.vue?vue&type=style&index=0&id=4a64d6a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64d6a9",
  null
  
)

export default component.exports